/**
 * Currency formatting utilities.
 * Default currency is INR (₹).
 */

const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£',
  AED: 'AED ',
  SGD: 'S$',
};

/**
 * Get the currency symbol for a given currency code.
 * @param {string} [currency='INR'] - Currency code (INR, USD, etc.)
 * @returns {string} Currency symbol
 */
export function getCurrencySymbol(currency = 'INR') {
  return CURRENCY_SYMBOLS[currency?.toUpperCase()] ?? CURRENCY_SYMBOLS.INR;
}

/**
 * Format a price with the appropriate currency symbol.
 * @param {number} amount - The amount to format
 * @param {string} [currency='INR'] - Currency code
 * @returns {string} Formatted string e.g. "₹1,000" or "$100.00"
 */
export function formatCurrency(amount, currency = 'INR') {
  const symbol = getCurrencySymbol(currency);
  const num = Number(amount);
  if (isNaN(num)) return `${symbol}0`;
  const formatted = Number.isInteger(num) ? num.toString() : num.toFixed(2);
  return `${symbol}${formatted}`;
}
